import { render, staticRenderFns } from "./FormularioCapacitacion.vue?vue&type=template&id=19e22033&scoped=true"
import script from "./FormularioCapacitacion.vue?vue&type=script&lang=js"
export * from "./FormularioCapacitacion.vue?vue&type=script&lang=js"
import style0 from "./FormularioCapacitacion.vue?vue&type=style&index=0&id=19e22033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e22033",
  null
  
)

export default component.exports